import React from 'react';

const GalleryImageCell = ({ src, alt, onClick, className }) => (
  <div
    role="button"
    tabIndex={0}
    className={`relative cursor-pointer overflow-hidden min-h-0 min-w-0 bg-neutral-200 ${className || ''}`}
    onClick={onClick}
    onKeyDown={(e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        onClick?.(e);
      }
    }}
  >
    <img
      src={src}
      alt={alt}
      className="absolute inset-0 h-full w-full object-cover object-center hover:opacity-95 transition-opacity pointer-events-none"
      draggable={false}
    />
  </div>
);

const VenueImageGallery = ({ 
  venue, 
  allImages, 
  getVenueImage, 
  onImageClick, 
  onShowAllPhotos 
}) => {
  // Use API images if available, otherwise use fallback images
  const hasApiImages = allImages && allImages.length > 0;
  
  const primaryImage = hasApiImages 
    ? allImages[0] 
    : { src: getVenueImage(0), caption: 'Main venue image' };
  
  const thumbnailsToShow = hasApiImages 
    ? allImages.slice(1, 5)
    : [
        { src: getVenueImage(1), caption: 'Venue image 2' },
        { src: getVenueImage(2), caption: 'Venue image 3' },
        { src: getVenueImage(3), caption: 'Venue image 4' }
      ];
  
  return (
    <section>
    <div className="w-full mb-6">
      <div className="vd-gallery relative grid grid-cols-12 gap-2 overflow-hidden md:h-[478px]">
        {/* Main Image - Left Side */}
        <GalleryImageCell
          className="col-span-12 md:col-span-6 h-64 sm:h-80 md:h-full"
          src={primaryImage.src}
          alt={primaryImage.caption || 'Venue'}
          onClick={() => onImageClick(primaryImage, 0)}
        />

        {/* Thumbnails Grid - Right Side */}
        <div className="col-span-12 md:col-span-6 grid grid-cols-2 grid-rows-2 gap-2 min-h-0 h-64 sm:h-80 md:h-full">
          {thumbnailsToShow.slice(0, 4).map((image, index) => {
            const showAllPhotosCta =
              index === 3 &&
              thumbnailsToShow.length === 4 &&
              hasApiImages &&
              allImages.length > 4;
            return (
              <div key={index} className="relative min-h-0 min-w-0 h-full">
                <GalleryImageCell
                  className="min-h-0 h-full w-full"
                  src={image.src}
                  alt={image.caption || `Thumbnail ${index + 1}`}
                  onClick={() => onImageClick(image, index + 1)}
                />
                {showAllPhotosCta && (
                  <button
                    type="button"
                    className="vd-show-all absolute bottom-3 right-3 z-[2]"
                    onClick={(e) => {
                      e.stopPropagation();
                      onShowAllPhotos();
                    }}
                  >
                    View gallery
                  </button>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
        </section>
  );
};

export default VenueImageGallery;

